import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY, SAN} from 'util/constants';

module.exports = {
    createFetchParams: (startDate, filters) => ({
        technology: filters.technology,
        volume:     filters.technology === SAN ? filters.volumeSAN : filters.volumeNAS,
        date:       Math.floor(startDate / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:               'storageAssigned',
        endpoint:           endpoints.storage.storageAssigned,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: response => {
            if (response.results) {
                return response.results.map(item => ({
                    assignedTb: item.assigned_tb,
                    usedTb:     item.used_tb,
                    period:     item.period
                }));
            }

            return [];
        }
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/storageAssigned.js